(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[75287],{

/***/ 75287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6572);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13305);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var OldArticle = function(param) {
    var oldBody = param.oldBody;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default().articleContent),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            dangerouslySetInnerHTML: (0,utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .createMarkup */ .KU)(oldBody)
        })
    });
};
OldArticle.propTypes = {
    oldBody: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["default"] = (OldArticle);


/***/ }),

/***/ 13305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2__pqv_a","articleContent":"styles_articleContent__pWtVT","h3":"styles_h3__61Cdv","paragraph":"styles_paragraph__p4IbS","a":"styles_a__b7cap","ul":"styles_ul__eYVaP","ol":"styles_ol__ICXO5","quote":"styles_quote__T8k_F"};

/***/ })

}]);